export default {
  en: {
    dayparts: 'Dayparts',
    daypart: 'Daypart',
    'daypart-breakfast': 'Breakfast',
    'daypart-dinner': 'Dinner',
    'daypart-evening': 'Evening',
    'daypart-lunch': 'Lunch',
    'daypart-snack': 'Snack',
    'daypart-late_night': 'Late Night',
    peaks: 'Peaks',
    'time-slices': 'Time Slices',
    'time-slice-time': 'Time',
    'delete-time-slice': 'Delete Time Slice',
    'delete-time-slice-confirm':
      'Are you sure you want to delete this time slice? This action cannot be undone.',
    scope: 'Scope',
    'scope-enterprise': 'Enterprise',
    'scope-org': 'Organization',
    'scope-user': 'Personal',
  },
  es: {
    dayparts: 'Partes del día',
    daypart: 'Parte del día',
    'daypart-breakfast': 'Desayuno',
    'daypart-dinner': 'Cena',
    'daypart-evening': 'Noche',
    'daypart-lunch': 'Almuerzo',
    'daypart-snack': 'Merienda',
    'daypart-late_night': 'Madrugada',
    peaks: 'Picos',
    'time-slices': 'Franjas Horarias',
    'time-slice-time': 'Hora',
    'delete-time-slice': 'Eliminar Franja Horaria',
    'delete-time-slice-confirm':
      '¿Está seguro de que desea eliminar esta franja horaria? Esta acción no se puede deshacer.',
    scope: 'Alcance',
    'scope-enterprise': 'Empresa',
    'scope-org': 'Organización',
    'scope-user': 'Personal',
  },
  fr: {
    dayparts: 'Périodes de la journée',
    daypart: 'Période de la journée',
    'daypart-breakfast': 'Petit-déjeuner',
    'daypart-dinner': 'Dîner',
    'daypart-evening': 'Soirée',
    'daypart-lunch': 'Déjeuner',
    'daypart-snack': 'Collation',
    'daypart-late_night': 'Fin de soirée',
    peaks: 'Pointes',
    'time-slices': 'Plages horaires',
    'time-slice-time': 'Heure',
    'delete-time-slice': 'Supprimer la plage horaire',
    'delete-time-slice-confirm':
      'Voulez-vous vraiment supprimer cette plage horaire ? Cette action est irréversible.',
    scope: 'Portée',
    'scope-enterprise': 'Entreprise',
    'scope-org': 'Organisation',
    'scope-user': 'Personnel',
  },
  // Québec meal names differ from France: breakfast/lunch/dinner are
  // déjeuner/dîner/souper here, not petit-déjeuner/déjeuner/dîner.
  'fr-ca': {
    dayparts: 'Périodes de la journée',
    daypart: 'Période de la journée',
    'daypart-breakfast': 'Déjeuner',
    'daypart-dinner': 'Souper',
    'daypart-evening': 'Soirée',
    'daypart-lunch': 'Dîner',
    'daypart-snack': 'Collation',
    'daypart-late_night': 'Fin de soirée',
    peaks: 'Périodes de pointe',
    'time-slices': 'Plages horaires',
    'time-slice-time': 'Heure',
    'delete-time-slice': 'Supprimer la plage horaire',
    'delete-time-slice-confirm':
      'Voulez-vous vraiment supprimer cette plage horaire? Cette action est irréversible.',
    scope: 'Portée',
    'scope-enterprise': 'Entreprise',
    'scope-org': 'Organisation',
    'scope-user': 'Personnel',
  },
};
